import { Controller } from 'stimulus';
import { accounting } from 'accounting';

export default class extends Controller {
  static targets = [ 'shipping', 'shippingTotal', 'orderTotal', 'shippingCost', 'storePickupCost',
                     'shippingDisplay', 'freeDeliveryBar', 'shippingTotalCost', 'billAddressCheckbox',
                     'billAddressForm', 'couponForm' ];

  initialize() {
    if (!this.hasShippingTotalTarget) return;

    this.changeLabels();

    this.shipmentTotal = this.shippingTotalTarget.dataset;

    this.formatOptions = {
      symbol: this.shipmentTotal.currency,
      decimal: this.shipmentTotal.decimalMark,
      thousand: this.shipmentTotal.thousandsSeparator,
      precision: this.shipmentTotal.precision,
      format: '%v %s',
    };

    if (document.getElementById('delivery').checked) {
      this.shippingDisplayTarget.style.display = 'flex';
      if (document.getElementById("free-delivery-cost-bar") !== null) {
        this.freeDeliveryBarTarget.innerHtml = this.readjustedFreeDeliveryBar(this.shippingTotalTarget.dataset.cost,
                                                                              this.parseCurrencyToFloat(this.orderTotalTarget.innerHTML),
                                                                              this.freeDeliveryBarTarget.dataset.freeDeliveryMinimum)
      }
    } else {
      this.shippingDisplayTarget.style.display = 'none';
    }

    this.navBarCart = document.getElementById('js-navbar-cart-button-display-total');

    if (this.hasShippingCostTarget && this.hasStorePickupCostTarget) {
      this.shippingCosts = {
        delivery: this.shippingCostTarget.dataset.cost,
        store: this.storePickupCostTarget.dataset.cost,
      };
    }

    const radioCheckedValue = document.querySelector('.js-radioTabs__trigger:checked');
    if (radioCheckedValue === undefined) return;
  }

  selectShippingMethod = (e) => {
    if (e.target.id === 'delivery' && this.shippingCostTarget.dataset.otcPopup === 'true') return;
    this.fetchShippingMethodData(e.target);
    this.changeLabels(e);
  }

  changeLabels = (e) => {
    const addressElement = document.getElementById('js-address-missing-data-delivery');
    const storeElement   = document.getElementById('js-order-delivery-method-store-title');
    if (addressElement === null && storeElement === null) return;

    if (e !== undefined && e.target.id === 'delivery') {
      addressElement.innerHTML = addressElement.dataset.deliveryAddressTitle;
      storeElement.innerHTML   = storeElement.dataset.deliveryAddressTitle;
    } else {
      addressElement.innerHTML = addressElement.dataset.storeAddressTitle;
      storeElement.innerHTML   = storeElement.dataset.storeAddressTitle;
    }
  }

  recalculatePrice = (e) => {
    this.readjustSummarySection(
      this.parseCurrencyToFloat(this.orderTotalTarget.innerHTML),
      this.parseCurrencyToFloat(this.shippingCosts[e.target.id])
    );
  }

  parseCurrencyToFloat = (input) => {
    return accounting.unformat(input, this.formatOptions.decimal);
  }

  readjustSummarySection = (orderTotal, newShipmentTotal) => {
    var displayTotal = accounting.formatMoney(accounting.toFixed(orderTotal, 10),
                                              this.formatOptions);

    var shippingTitle = this.shippingTotalTarget.dataset.titleLabel;
    this.shippingTotalTarget.innerHTML = shippingTitle
    this.shippingTotalCostTarget.innerHTML = accounting.formatMoney(newShipmentTotal, this.formatOptions);

    this.hideOrShowShippingTotal(newShipmentTotal);

    if (this.navBarCart) {
      this.navBarCart.innerHTML = displayTotal;
    }

    return this.orderTotalTarget.innerHTML = displayTotal;
  }

  fetchShippingMethodData = async (shipment) => {
    const shippingRateId = shipment.value
    const shipmentId = document.getElementById("order_shipments_attributes_0_id").value
    const authToken = document.getElementsByName("authenticity_token")[0].value
    try {
      const response = await fetch(`/checkout/select_delivery_method`, {
        method: 'POST',
        body: JSON.stringify({
          authenticity_token: `${authToken}`,
          order: {
            shipments_attributes:
              { 0: {
                    selected_shipping_rate_id: `${shippingRateId}`,
                    id: `${shipmentId}`
                }
              }
          }
        }),
        headers: {
          "Content-type": "application/json; charset=UTF-8"
        }
      })
      const data  = await response.json()
      if (data.error !== undefined) return
      this.readjustSummarySection(data.orderTotal, data.shippingCost)
      this.hideOrShowBillAddressCheckbox(shipment.id)
      this.hideCouponsWithCode(data.activeCouponsWithCode)

      var freeDeliveryCoupon = document.getElementById("applied-promotion-free-delivery")
      if (freeDeliveryCoupon !== null) freeDeliveryCoupon.remove()
      this.buildFreeDeliveryBar(data)
    } catch (_) {}
  }

  hideCouponsWithCode = (activeCoupons) => {
    if (activeCoupons === "true") return

    var activeCoupon = document.getElementById("applied-coupon-with-code")
    if (activeCoupon === null) return

    activeCoupon.remove()
    this.couponFormTarget.style.display = "block";
  }

  buildFreeDeliveryBar = (data) => {
    if (parseFloat(data.shipmentTotal) > 0) {
      this.freeDeliveryBarTarget.innerHTML = this.readjustedFreeDeliveryBar(data.shippingCost,
        data.orderTotal,
        data.freeDeliveryMinAmount)
    } else {
      this.freeDeliveryBarTarget.innerHTML = this.readjustedFreeDeliveryBar(0,
        data.orderTotal,
        0)
      if (parseFloat(data.shippingCost) > 0) this.buildFreeDeliveryCoupon(data.freeAutoShippingPromotion)
    }
  }

  buildFreeDeliveryCoupon = (freeShippingPromotionData) => {
    var appliedCoupons = document.getElementById("applied-coupons")
    appliedCoupons.innerHTML = appliedCoupons.innerHTML + this.freeDeliveryCouponTemplate(freeShippingPromotionData)
  }

  hideOrShowShippingTotal = (total) => {
    if (total > 0) {
      this.shippingDisplayTarget.style.display = 'flex';
    } else {
      this.shippingDisplayTarget.style.display = 'none';
    }
  }

  hideOrShowBillAddressCheckbox = (shippingMethod) => {
    if (shippingMethod === "delivery") {
      this.billAddressCheckboxTarget.style.display = '';
      this.billAddressFormTarget.style.display = '';
    } else {
      this.billAddressCheckboxTarget.style.display = 'none';
      this.billAddressFormTarget.style.display = 'none';
    }
  }

  readjustedFreeDeliveryBar = (shippingCost, orderTotal, freeDeliveryMinimum) => {
    if (freeDeliveryMinimum === null) {
      return " "
    }
    var freeDeliveryPercentage = 100
    var freeDeliveryTotalAmount = 0
    if (shippingCost > 0) {
      var freeDeliveryAmount = parseFloat(freeDeliveryMinimum)
      freeDeliveryPercentage = Math.round(((orderTotal / freeDeliveryAmount) * 100))
      freeDeliveryTotalAmount = (freeDeliveryAmount - orderTotal).toFixed(2)
    }

    if (freeDeliveryPercentage > 100) {
      freeDeliveryPercentage = 100
      freeDeliveryTotalAmount = 0
    }

    return this.freeDeliveryBarTemplate(freeDeliveryPercentage, freeDeliveryTotalAmount)
  }

  freeDeliveryCouponTemplate = (freeDeliveryCouponData) => {
    const deliveryCouponMoney = accounting.formatMoney(accounting.toFixed(freeDeliveryCouponData.amount, 10), this.formatOptions);

    return `<div class="flex justify-between " id="applied-promotion-free-delivery">
      <span class="delivery-cart__total-price__price-label">
        ${freeDeliveryCouponData.label}
      </span>
      <div class="d-flex flex-column items-end">
        <span class="delivery-cart__total-price__price-value flex justify-end">
          ${deliveryCouponMoney}
        </span>
      </div>
    </div>`
  }

  freeDeliveryBarTemplate = (freeDeliveryPercentage, freeDeliveryTotalAmount) => {
    var deliveryBarMessage = ''

    if (freeDeliveryPercentage === 100) {
      deliveryBarMessage = `Dostava je <strong>besplatna</strong>.`
    } else {
      deliveryBarMessage = `Do <strong> besplatne dostave</strong> nedostaje vam <strong>${freeDeliveryTotalAmount} €</strong>.`
    }

    return `<p>
              <span>
                ${deliveryBarMessage}
              </span>
            </p>
            <div class="delivery-cart__free-delivery__percent-box">
              <div class="delivery-cart__free-delivery__percent-box-percent" style="width: ${freeDeliveryPercentage}% !important;">
              </div>
            </div>`
  }
}
